import { render, staticRenderFns } from "./SeriousAdverseEventsTable.vue?vue&type=template&id=227ba1d7&"
import script from "./SeriousAdverseEventsTable.vue?vue&type=script&lang=js&"
export * from "./SeriousAdverseEventsTable.vue?vue&type=script&lang=js&"
import style0 from "./SeriousAdverseEventsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports